import * as React from 'react';

function SvgPicture(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={34.505} height={28.035} {...props}>
      <path
        d="M0 0v28.035h34.5V0zm32.348 25.879H2.157V2.157h30.191zM23.722 7.548a3.235 3.235 0 103.235-3.235 3.235 3.235 0 00-3.235 3.235zm6.47 16.174H4.313l6.47-17.252 8.626 10.783 4.313-3.235z"
        data-name="Path 473"
      />
    </svg>
  );
}

export default SvgPicture;
